module.exports = __webpack_public_path__ + "img/xuexiyule.aeec3a13.png";